/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import { func } from 'prop-types'
import styled from 'styled-components'
import Form from '@taglivros/oef_componentes/build/components/form'
import Input from '@taglivros/oef_componentes/build/components/input'
import { validacaoSenha } from '../../../utils/validadores/validadores'

import {
  ID_INPUT_SENHA_ANTIGA,
  ID_INPUT_SENHA_NOVA,
  LABEL_SENHA_ANTIGA,
  LABEL_SENHA_NOVA,
} from '../constantsPerfil'
import { REQUIRED_MESSAGE } from '../../../constants'
import { empty, isEmptyObject } from '../../../utils/helpers/helpers'

const WrapperFormSenha = styled.div`
  margin-top: 20px;

  & > div {
    position: relative;
    z-index: 1;
  }

  .form__row {
    margin: 20px 0;
  }
`

const FormAlterarSenha = ( { onConfirmar } ) => {
  const [ state, setState ] = useState( {} )
  const [ erros, setErros ] = useState( {} )
  const [ sucessos, setSucessos ] = useState( {} )
  const [ camposObrigatoriosPreenchidos, setCamposObrigatoriosPreenchidos ] = useState( false )
  const camposObrigatorios = [ ID_INPUT_SENHA_ANTIGA, ID_INPUT_SENHA_NOVA ]

  useEffect( () => {
    const camposObrigatoriosComSucesso = Object.keys( sucessos ).every( sucesso => sucessos[ sucesso ] )
    if ( !isEmptyObject( state ) && camposObrigatoriosComSucesso ) {
      const hasPreenchimento = camposObrigatorios.reduce( ( acumulador, campoObrigatorio ) => {
        return !empty( state[ campoObrigatorio ] ) && acumulador
      }, true )

      setCamposObrigatoriosPreenchidos( hasPreenchimento )
    }
  }, [ state, sucessos ] )

  useEffect( () => {
    if ( camposObrigatoriosPreenchidos ) {
      onConfirmar( state )
    }
  }, [ camposObrigatoriosPreenchidos, state ] )

  const validate = ( event, isOnSubmit=false ) => {
    const { name, value } = event.target
    let validacaoErros = erros

    const senhaInvalida = name === ID_INPUT_SENHA_NOVA ? validacaoSenha( value ) : false

    if ( value === '' && !isOnSubmit ) {
      validacaoErros = {
        ...erros,
        [ name ]: REQUIRED_MESSAGE
      }
    } else if ( senhaInvalida ) {
      validacaoErros = {
        ...erros,
        [ name ]: senhaInvalida
      }
    } else if ( !camposObrigatoriosPreenchidos && isOnSubmit ) {
      const obrigatoriosNaoPreenchidos = camposObrigatorios.reduce( ( acumulador, obrigatorio ) => {
        if ( empty( state[ obrigatorio ] ) ) {
          return {
            ...acumulador,
            [ obrigatorio ]: REQUIRED_MESSAGE
          }
        }

        return acumulador
      }, {} )

      validacaoErros = obrigatoriosNaoPreenchidos
    }

    setSucessos( {
      ...sucessos,
      [ name ]: empty( validacaoErros[ name ] ) && !empty( state[ name ] )
    } )

    setErros( validacaoErros )
  }

  const handleChange = event => {
    const { name, value } = event.target

    setErros( {
      ...erros,
      [ name ]: null
    } )

    setSucessos( {
      ...sucessos,
      [ name ]: null
    } )

    setState( {
      ...state,
      [ name ]: value
    } )
  }

  const handleBlur = event => {
    const { name } = event.target
    if ( camposObrigatorios.includes( name ) ) {
      validate( event )
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
    validate( event, true )
    if ( onConfirmar && sucessos[ 'senha-antiga' ] === true && sucessos[ 'senha-nova' ] === true ) {
      onConfirmar( state )
    }
  }

  return (
    <Form>
      <WrapperFormSenha>
        <div className="form__row">
          <Form.INPUT
            erro={ erros[ ID_INPUT_SENHA_ANTIGA ] }
            isPassword
            label={ LABEL_SENHA_ANTIGA }
            name={ ID_INPUT_SENHA_ANTIGA }
            onBlur={ handleBlur }
            onChange={ handleChange }
            onPressEnter={ handleSubmit }
            sucesso={ sucessos[ ID_INPUT_SENHA_ANTIGA ] }
            tipo={ Input.TIPO_SENHA }
            value={ state[ ID_INPUT_SENHA_ANTIGA ] }
          />
        </div>

        <div className="form__row">
          <Form.INPUT
            erro={ erros[ ID_INPUT_SENHA_NOVA ] }
            isPassword
            label={ LABEL_SENHA_NOVA }
            name={ ID_INPUT_SENHA_NOVA }
            onBlur={ handleBlur }
            onChange={ handleChange }
            onPressEnter={ handleSubmit }
            sucesso={ sucessos[ ID_INPUT_SENHA_NOVA ] }
            tipo={ Input.TIPO_SENHA }
            value={ state[ ID_INPUT_SENHA_NOVA ] }
          />
        </div>
      </WrapperFormSenha>
    </Form>
  )
}

FormAlterarSenha.propTypes = {
  'onConfirmar': func.isRequired
}

export default FormAlterarSenha
